// Reads go through the SECURITY DEFINER views (profile_directory /
// supplier_public_profiles), NOT the base profiles table. The base table is
// locked to self/admin by RLS; the views expose only non-sensitive columns
// (never email or payout_* bank fields) so cross-user identity/supplier lookups
// keep working for any authenticated/anon caller.
export async function fetchProfileDirectoryByIds(sb, ids = []) {
  if (!ids.length) return [];
  const { data } = await sb
    .from('profile_directory')
    .select('id, full_name, company_name, company_name_latin, role, status, avatar_url, city, country, speciality, maabar_supplier_id, lang, rating, reviews_count, years_experience, year_established, factory_images')
    .in('id', ids);
  return data || [];
}

export async function fetchSupplierPublicProfileById(sb, id) {
  if (!id) return null;
  const { data } = await sb
    .from('supplier_public_profiles')
    .select('id, full_name, company_name, company_name_latin, role, status, avatar_url, city, country, speciality, maabar_supplier_id, bio_ar, bio_en, bio_zh, factory_images, min_order_value, languages, rating, reviews_count, year_established, business_type, customization_support, company_address, company_description, export_markets, certifications, years_experience, completion_rate, company_website, export_years')
    .eq('id', id)
    .single();
  return data || null;
}

// FIXED 2026-09-28: the 4th argument used to be IGNORED — every caller passed
// 'profiles' and read `.profiles`, while this always wrote `_profile`, which
// nothing reads. So the supplier's samples, inquiries and reviews lists never
// showed a name. profileKey now decides where the profile lands.
//
// profile_directory withholds a TRADER's name/company until the supplier may
// see it (can_see_trader_identity — an accepted offer or a confirmed direct
// order), so a caller attaching buyers gets the name exactly when the owner's
// rule allows it, and null fields otherwise — never the profiles table, which
// RLS keeps self-or-admin.
export async function attachDirectoryProfiles(sb, items = [], idKey = 'supplier_id', profileKey = '_profile') {
  if (!items.length) return items;
  const ids = [...new Set(items.map(i => i[idKey]).filter(Boolean))];
  if (!ids.length) return items;
  const profiles = await fetchProfileDirectoryByIds(sb, ids);
  const map = Object.fromEntries(profiles.map(p => [p.id, p]));
  return items.map(item => ({ ...item, [profileKey]: map[item[idKey]] || null }));
}

export async function attachSupplierProfiles(sb, items = [], idKey = 'supplier_id', profileKey = 'profiles') {
  if (!items.length) return items;
  const ids = [...new Set(items.map(i => i[idKey]).filter(Boolean))];
  if (!ids.length) return items;
  const profiles = await fetchProfileDirectoryByIds(sb, ids);
  const map = Object.fromEntries(profiles.map(p => [p.id, p]));
  return items.map(item => ({ ...item, [profileKey]: map[item[idKey]] || null }));
}